// Cliente axios + endpoints del modulo Mensajes de contacto. Mismo patron
// liviano sin redux que usuariosApi.js / configuracionApi.js.
import axios from "axios";
import { PATH } from "../../redux/utils";

export const apiMensajesContacto = axios.create({ baseURL: PATH });

export const authHeaderMensajesContacto = () => {
  const token = localStorage.getItem("token");
  if (!token) return {};
  return { Authorization: `Bearer ${token}` };
};

const H = () => ({ headers: authHeaderMensajesContacto() });

export const getMensajesContacto = (estado) =>
  apiMensajesContacto.get("/mensajes-contacto", { ...H(), params: estado ? { estado } : undefined });

export const getMensajeContacto = (id) => apiMensajesContacto.get(`/mensajes-contacto/${id}`, H());

export const responderMensajeContacto = (id, payload) =>
  apiMensajesContacto.post(`/mensajes-contacto/${id}/responder`, payload, H());
